import * as React from 'react';

export interface IMapUnitRenderProps {
  value: number;
}

const UnitFormatter = new Intl.NumberFormat('it-IT', {
  style: 'decimal',
  maximumFractionDigits: 2,
  useGrouping: true,
});

export function formatMapUnit(value: number) {
  return `${UnitFormatter.format(value)} mq`;
}

export function renderMapUnit(unit: 'mq', value: number) {
  return `${UnitFormatter.format(value)} ${unit}`;
}

export function MapUnitRender(props: IMapUnitRenderProps) {
  const { value } = props;
  if (!value) return null;
  return <span>{UnitFormatter.format(value)} mq</span>;
}
